//  Material-UI  theme  configuration
//  This  defines  colors,  fonts,  and  styling  for  the  entire  app

import  {  createTheme  }  from  '@mui/material/styles';

export  const  theme  =  createTheme({
    //  Color  palette
    palette:  {
        primary:  {
            main:  '#478dbc',  //  Your  custom  blue  -  modern  and  professional
            light:  '#6fa8d1',
            dark:  '#2d6a92',
        },
        secondary:  {
            main:  '#000e3f',  //  Your  custom  dark  blue
            light:  '#1a2d5f',
            dark:  '#000a2a',
        },
        success:  {
            main:  '#10B981',  //  Emerald  -  for  approved/success  states
            light:  '#34D399',
            dark:  '#059669',
        },
        error:  {
            main:  '#EF4444',  //  Red  -  for  errors  and  rejections
        },
        warning:  {
            main:  '#F59E0B',  //  Amber  -  for  pending  states
        },
        info:  {
            main:  '#478dbc',  //  Use  your  primary  blue  for  info
        },
        background:  {
            default:  '#F9FAFB',  //  Light  gray  background
            paper:  '#FFFFFF',
        },
    },
    
    //  Typography
    typography:  {
        fontFamily:  '"Inter",  "Roboto",  "Helvetica",  "Arial",  sans-serif',
        h4:  {
            fontWeight:  600,
        },
        h5:  {
            fontWeight:  600,
        },
        h6:  {
            fontWeight:  600,
        },
    },
    
    //  Component  overrides
    components:  {
        MuiButton:  {
            styleOverrides:  {
                root:  {
                    textTransform:  'none',  //  Buttons  show  normal  text,  not  ALL  CAPS
                    borderRadius:  8,
                },
            },
        },
        MuiCard:  {
            styleOverrides:  {
                root:  {
                    borderRadius:  12,
                    boxShadow:  '0  1px  3px  0  rgb(0  0  0  /  0.1)',
                },
            },
        },
    },
});
